export enum ProfileMenuEnum {
  PERSONAL_INFO = 'personal-info',
  CERTIFICATES = 'certificates',
  CHANGE_PASSWORD = 'change-password',
  PRIVACY_POLICIES = 'privacy-policies',
}